import { render } from "./Suggestion.vue?vue&type=template&id=1197723e&scoped=true"
import script from "./Suggestion.vue?vue&type=script&lang=js"
export * from "./Suggestion.vue?vue&type=script&lang=js"

import "./Suggestion.vue?vue&type=style&index=0&id=1197723e&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1197723e"]])

export default __exports__